module.exports = __webpack_public_path__ + "static/media/login-icon.083aa37b.svg";